import React, { useEffect, useState } from "react";
import {
  BulbOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import {
  Button,
  Modal,
  Form,
  Input,
  Select,
  InputNumber,
  Space,
  Table,
  Tag,
  Popconfirm,
} from "antd";
import { GeneralService } from "../../../Services/GeneralService";
import { notify } from "../../../components/Customs/NotifyProvider";
import { formatDate } from "../../../components/Customs/dateFormatter";
import { RoomServices } from "../../../Services/RoomServices";

export default function ServiceRequestModal({
  open,
  onClose,
  room,
  form,
  loading,
  allBookings
}) {
  const [localForm] = Form.useForm();

  const [serviceType, setServiceType] = useState("inhouse");
  const [inHouseServices, setInHouseServices] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [extVal, setExtVal] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState('pending')

  console.log("allBookings",allBookings);
  

  useEffect(() => {
    if (open) {
      getPreRequest( allBookings[0]?.bl_id, allBookings[0]?.br_id)
    }
  }, [open]);


  console.log("bl_id:", allBookings[0]?.bl_id);
  console.log("br_id:", allBookings[0]?.br_id);

  const getAllServices = async () => {
    try {
      const res = await GeneralService.get("inhouse_services");

      setInHouseServices(
        (res.data || []).map((item, index) => ({
          si_no: index + 1,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getPreRequest = async (bl_id, br_id) => {
    try {
      const res = await GeneralService.getServiceRequests("service_requests", bl_id, br_id);

      setTableData(res.data || []);

      setPaymentStatus(res.data[0].status)


      if (Array.isArray(res.data) && res.data.length > 0) {
        setExtVal(true);
      } else {
        setExtVal(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllServices();
    getPreRequest(allBookings[0]?.bl_id, allBookings[0]?.br_id)
  }, [allBookings[0]?.bl_id, allBookings[0]?.br_id]);

  // ➕ Insert row
  const handleInsert = async () => {
    try {
      const values = await localForm.validateFields();

      console.log("values", values);

      const selectedService = inHouseServices.find(
        (s) => s.id === values.inhouse_service_id
      );

      const price =
        values.service_type === "inhouse"
          ? Number(selectedService?.price || 0)
          : Number(values.price || 0);

      const row = {
        service_type: values.service_type,
        service_name:
          values.service_type === "custom"
            ? values.service_name
            : null,
        inhouse_service_name:
          values.service_type === "inhouse"
            ? selectedService?.name
            : null,
        category:
          values.category || selectedService?.category,
        price: price,
        quantity: values.quantity || 1,
        total_amount: price * (values.quantity || 1),
        status: "pending",
      };

      setTableData((prev) => [...prev, row]);

      localForm.resetFields([
        "service_name",
        "price",
        "quantity",
        "inhouse_service_id",
      ]);
    } catch (error) {
      console.log("Validation Failed:", error);

      // ✅ optional user message
      notify.error("Required !", "Please fill required fields");
    }
  };

  // ✏️ Handle inline edits
  const handleFieldChange = (id, field, value) => {
    const updated = tableData.map((item) => {
      if (item.sr_id === id) {
        const updatedItem = { ...item, [field]: value };

        updatedItem.total_amount =
          (updatedItem.price || 0) *
          (updatedItem.quantity || 1);

        return updatedItem;
      }
      return item;
    });

    setTableData(updated);
  };

  // ❌ Delete row
  const handleDeleteRow = async (id) => {

    console.log("id delete", id);

    const req = await GeneralService.deleteBySrId("service_requests", id);

    if (req.status) {
      notify.success("Deleted", req.message);

      setTableData((prev) =>
        prev.filter((item) => item.sr_id !== id)
      );
    } else {
      notify.error("Failed !", req.message || "Something went wrong");
    }

  };

  // ✅ Final Submit
  const handleConfirm = async () => {

    console.log("bl_id:", form);
    // console.log("br_id:", allBookings[0]?.br_id);

    const enrichedServices = tableData.map((item) => ({
      ...item,
      bl_id: allBookings[0]?.bl_id,
      br_id: allBookings[0]?.br_id,
      created_at: formatDate(),
      updated_at: formatDate()
    }));

    console.log("Final Table Data:", enrichedServices);

    const payload = {
      room_id: room?.id,
      services: tableData,
    };

    try {
      const request = await GeneralService.create("service_requests", enrichedServices);

      if (request.status) {
        notify.success("Success", request.message);
        onClose();
      } else {
        notify.error("Failed", request.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);

    }

    // setTableData([]);
    // localForm.resetFields();
  };
  const handleUpdate = async () => {


    const enrichedServices = tableData.map((item) => ({
      ...item,
      bl_id: allBookings[0]?.bl_id,
      br_id: allBookings[0]?.br_id,
      updated_at: formatDate()
    }));

    console.log("Final Table Data:", enrichedServices);

    const payload = {
      room_id: room?.id,
      services: tableData,
    };

    try {
      const request = await RoomServices.editServiceRequest(enrichedServices);

      if (request.status) {
        notify.success("Success", request?.message);
        onClose();
      } else {
        notify.error("Failed", request?.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);

    }

    // setTableData([]);
    // localForm.resetFields();
  };

  const handleCancel = () => {
    setTableData([]);
    localForm.resetFields();
    onClose();
  };

  const totalQty = tableData.reduce(
    (sum, item) => sum + Number(item.quantity || 0),
    0
  );

  const grandTotal = tableData.reduce(
    (sum, item) => sum + Number(item.total_amount || 0),
    0
  );

  const handleStatusChange = async (options, values) => {
    console.log(options);
    console.log(allBookings[0]?.bl_id);
    console.log(allBookings[0]?.br_id);


    try {
      const req = await RoomServices.updatePaymentStatus(
        allBookings[0]?.br_id,
        allBookings[0]?.bl_id,

        { status: options }

      );

      if (req.status) {
        notify.success(req?.message)
        getPreRequest(allBookings[0]?.bl_id, allBookings[0]?.br_id)
      } else {
        notify.error(req?.message)
      }

    } catch (error) {
      console.log(error);

    }

  }

  // 📊 Columns with full editing
  const columns = [
    {
      title: "S. No.",
      render: (_, __, index) => index + 1,
      width: 70,
    },
    {
      title: "Service",
      render: (record) =>
        record.service_type === "custom" ? (
          <Input
            value={record.service_name}
            onChange={(e) =>
              handleFieldChange(
                record.sr_id,
                "service_name",
                e.target.value
              )
            }
          />
        ) : (
          record.inhouse_service_name
        ),
    },
    {
      title: "Type",
      dataIndex: "service_type",
      render: (val) => (
        <Tag color={val === "inhouse" ? "blue" : "purple"}>
          {val.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Category",
      render: (record) => (
        <Input
          value={record.category}
          onChange={(e) =>
            handleFieldChange(
              record.sr_id,
              "category",
              e.target.value
            )
          }
        />
      ),
    },
    {
      title: "Qty",
      render: (record) => (
        <InputNumber
          min={1}
          value={record.quantity}
          onChange={(val) =>
            handleFieldChange(
              record.sr_id,
              "quantity",
              val
            )
          }
        />
      ),
    },
    {
      title: "Price",
      render: (record) => (
        <InputNumber
          min={0}
          // disabled={record.service_type === "inhouse"}
          value={record.price}
          onChange={(val) =>
            handleFieldChange(
              record.sr_id,
              "price",
              val
            )
          }
        />
      ),
    },
    {
      title: "Total",
      dataIndex: "total_amount",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        const color =
          status === "paid"
            ? "green"
            : status === "pending"
              ? "red"
              : "orange";

        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: "Actions",
      render: (record) => (
        <Space>
          <Popconfirm
            title="Delete request?"
            onConfirm={() =>
              handleDeleteRow(record.sr_id)
            }
          >
            <Button danger type="link">
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      width={1200}
      centered
      destroyOnClose
      title={
        <div style={{ display: "flex", gap: 8 }}>
          <BulbOutlined />
          <b>Service Request</b>
        </div>
      }
      footer={[
        <Space>
          <Form layout="inline"
            style={{ marginRight: 10 }}
          >
            <Form.Item label="Payment Status">
              <Select
                placeholder="Update payment status"
                defaultValue={paymentStatus}
                style={{ width: "100px" }}
                options={[
                  { value: "paid", label: "Paid" },
                  { value: "pending", label: "Pending" }
                ]}
                onChange={handleStatusChange}
              />
            </Form.Item>
          </Form>
        </Space>,
        <Button key="cancel" onClick={handleCancel}>
          Close
        </Button>,

        !extVal ? (
          <Button
            key="confirm"
            type="primary"
            loading={loading}
            icon={<LogoutOutlined />}
            onClick={handleConfirm}
          >
            Add Service
          </Button>
        ) : (
          <Button
            key="update"
            type="primary"
            loading={loading}
            icon={<LogoutOutlined />}
            onClick={handleUpdate}
          >
            Update Service
          </Button>
        ),

      ]}
    >
      {/* 🧾 Form */}
      <Form form={localForm} layout="vertical">
        <Space style={{ display: "flex" }} size={10}>
          <Form.Item
            name="service_type"
            label="Service Type"
            initialValue="inhouse"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: 150 }}
              onChange={(val) => setServiceType(val)}
              options={[
                { label: "Inhouse", value: "inhouse" },
                { label: "Custom", value: "custom" },
              ]}
            />
          </Form.Item>

          {/* Inhouse */}
          {serviceType === "inhouse" && (
            <Form.Item
              name="inhouse_service_id"
              label="Select Service"
              rules={[{ required: true }]}
            >
              <Select
                style={{ width: 220 }}
                placeholder="Select service"
                options={inHouseServices.map((s) => ({
                  label: `${s.name} (₹${s.price})`,
                  value: s.id,
                }))}
              />
            </Form.Item>
          )}

          {/* Custom */}
          {serviceType === "custom" && (
            <Form.Item
              name="service_name"
              label="Service Name"
              rules={[{ required: true }]}
            >
              <Input placeholder="Enter service" />
            </Form.Item>
          )}

          <Form.Item name="category" label="Category">
            <Input />
          </Form.Item>

          {serviceType === "custom" && (
            <Form.Item
              name="price"
              label="Price"
              rules={[{ required: true }]}
            >
              <InputNumber />
            </Form.Item>
          )}

          <Form.Item
            name="quantity"
            label="Qty"
            initialValue={1}
          >
            <InputNumber min={1} />
          </Form.Item>

          <Form.Item label=" ">
            <Button type="primary" onClick={handleInsert}>
              Insert
            </Button>
          </Form.Item>
        </Space>
      </Form>

      {/* 📊 Table */}
      <Table
        columns={columns}
        dataSource={tableData}
        rowKey="sr_id"
        pagination={false}
        footer={() => (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 40,
              fontWeight: 600,
            }}
          >
            <span>Total Qty: {totalQty}</span>
            <span>Grand Total: ₹{grandTotal}</span>
          </div>
        )}
      />
    </Modal>
  );
}